import { Surface } from "@payments-checkout/shared/components"
import { StatusTracker, Text } from "@stone-payments/jade"
import { useIntl } from "react-intl"
import { useRecurrenceValues } from "../../hook/useRecurrence/useRecurrenceValues.hook"

export const RecurrenceStatusTracker = () => {
  const { isRecurrence, statusProps } = useRecurrenceValues()
  const { formatMessage } = useIntl()
  if (!isRecurrence) return null
  return (
    <Surface backgroundColor="surface" className="p-jade-200 flex flex-col gap-jade-250" role="presentation">
      <Text variant="heading-small">{formatMessage({ id: "recurrenceStatusCard.card.title" })}</Text>
      <StatusTracker
        direction="vertical"
        items={statusProps}
      />
    </Surface>
  )
}
